import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { TextStyled } from './styles/TextStyled';

const Text = ({
  children,
  isMobile,
  hover,
  tag,
  color,
  size,
  type,
  font,
  disable,
  getRef,
  className,
  fixedSize,
  ...props
}) => (
  <TextStyled
    {...props}
    className={className}
    as={tag}
    type={type}
    color={color}
    size={size}
    font={font}
    isMobile={isMobile}
    ref={getRef}
    hover={hover}
    disable={disable}
    fixedSize={fixedSize}
  >
    {children}
  </TextStyled>
);

Text.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  font: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  type: PropTypes.string,
  hover: PropTypes.string,
  disable: PropTypes.bool,
  isMobile: PropTypes.bool,
  getRef: PropTypes.func,
  className: PropTypes.string,
  fixedSize: PropTypes.bool,
};

Text.defaultProps = {
  tag: 'span',
  size: '',
  color: '',
  font: '',
  children: '',
  hover: '',
  className: '',
  type: '',
  disable: false,
  isMobile: false,
  getRef: Function.prototype,
  fixedSize: false,
};

export default memo(Text);
